import React from 'react';
import Header from '../../Components/Header';

const HotelDetail = () => (
  <>
    <Header></Header>
    <section className='Booking_flight'>
      <div className='container_box'>
        <div className='row'>
          <div className='col-md-12 col-lg-12'>
            <div className='box_shadow mb-4 hotl_nm'>
              <h1>Estrela Do Mar Beach Resort</h1>
              <div className='start_cat'>
                <i class="star"></i>
                <i class="star"></i>
                <i class="star"></i>
                <i class="star"></i>
              </div>
              <p><i className='fa fa-location-dot'></i> B 374 Outer Ring Road Meera Bagh New Delhi 110063 India Outer Ring Road, Paschim Vihar, Meera BaghPaschim ViharNew Delhi 110063, New Delhi, 110063, India</p>
            </div>
          </div>
          <div className='col-md-8 col-lg-8'>
            <div className='hotl_big_img'>
              <img src='/assets/images/hotel/hotel-big.jpg' alt='hoel' />
            </div>
          </div>
          <div className='col-md-4 col-lg-4'>
            <div className='small_top'>
              <img src='/assets/images/hotel/hotel-top.jpg' alt='hoel' />
            </div>
            <div className='small_botom'>
              <img src='/assets/images/hotel/hotel-botom.jpg' alt='hoel' />
            </div>
          </div>
        </div>
<div className='row'>
  <div className='col-md-12 col-lg-12'>
    <div className='details_viw'>
      <h3 className='mb-3'>Overview</h3>
      <p>Fortune Sector 27, Noida - Member ITC Hotels Group is located in the city of Noida, beside the shopping hub of sector 18. It features a rooftop pool, a restaurant and rooms with flat-screen satellite TV.

All rooms at the Fortune Sector 27, Noida - Member ITC Hotels Group are equipped with a tea/coffee maker, electronic safe, and mini bar. A hair dryer and daily newspaper are provided.

Guests can enjoy free Wi-Fi in the Fortune Sector 27, Noida - Member ITC Hotels Group’s lobby area. A fitness centre provides guests a place to exercise during their stay. Steam, sauna and massage rooms are also available.

North Indian cuisine is served at the hotel’s restaurant, which provides free internet access. Other dining options include a Deli.

Fortune Sector 27, Noida - Member ITC Hotels Group is 35 km from Indira Gandhi International Airport. The city centre of New Delhi is 18 km away. Please inform Fortune Sector 27, Noida - Member ITC Hotels Group in advance of your expected arrival time. You can use the Special Requests box when booking, or contact the property directly with the contact details provided in your confirmation.
Guests are required to show a photo identification and credit card upon check-in. Please note that all Special Requests are subject to availability and additional charges may apply.
Payment before arrival via bank transfer is required. The property will contact you after you book to provide instructions.
In accordance with government guidelines to minimise transmission of the Coronavirus (COVID-19), this property currently isnt accepting guests from certain countries, during dates where such guidelines exist.
In response to Coronavirus (COVID-19), additional safety and sanitation measures are in effect at this property.
Food &amp; beverage services at this property may be limited or unavailable due to Coronavirus (COVID-19).
In accordance with government guidelines to minimise transmission of the Coronavirus (COVID-19), this property can only accept bookings from essential workers/permitted travellers, during dates where such guidelines exist. Reasonable evidence must be provided on arrival. If it isnt provided, your booking will be cancelled on arrival.
As a result of Coronavirus (COVID-19), this property has temporarily suspended its shuttle services.
Due to Coronavirus (COVID-19), this property is taking steps to help protect the safety of guests and staff. Certain services and amenities may be reduced or unavailable as a result.
Due to Coronavirus (COVID-19), this property has reduced reception and service operating hours.
In accordance with government guidelines to minimise transmission of the Coronavirus (COVID-19), this property may request additional documentation from guests to validate identity, travel itinerary and other relevant information, during dates where such guidelines exist.
Spa and gym facilities at this property are unavailable due to Coronavirus (COVID-19).
Due to Coronavirus (COVID-19), this property adheres to strict physical distancing measures.
Due to Coronavirus (COVID-19), please ensure that you are only booking this property following the local government guidelines of the destination, including but not limited to the purpose of travel, and maximum allowed group size.
Due to Coronavirus (COVID-19), wearing a face mask is mandatory in all indoor common areas.
It is not possible to stay at this property for Coronavirus (COVID-19) quarantine purposes.
A negative Coronavirus (COVID-19) PCR test result is mandatory to check-in to this property.<br /><b>Disclaimer notification: Amenities are subject to availability and may be chargeable as per the hotel policy.</b></p>

      <h3>Choose Room</h3>
      <table className='table table-bordered'>
<thead>
  <tr>
    <th>Room Type</th>
    <th>Select Guest</th>
    <th>Options</th>
    <th>Price</th>
  </tr>
</thead>
<tbody>
  <tr>
    <td>Deluxe Room (Deluxe Room),2 Twin Beds and 1 King Bed,NonSmoking</td>
    <td>2 Adults, 0 Child</td>
    <td>
      <p className='roon_only'>Room Only</p>
      <p className='refnt'>Non Refundable</p>
      <p><strong>Cancellation Policy </strong> </p>
      <p>100.0% Deduction From 18 Sep 2025 till check-in</p>
    </td>
    <td>
      <p className='prce'>Price For 1 Night</p>
      <h4 className='cll_rupe'> <i className='fa fa-inr'></i> 15428 </h4>
       <a href='/Hotel/HotelBooking' className='bok-now'>Book</a>
    </td>
  </tr>
  
  <tr>
    <td>Deluxe Room (Deluxe Room),2 Twin Beds and 1 King Bed,NonSmoking</td>
    <td>2 Adults, 0 Child</td>
    <td>
      <p className='roon_only'>Room Only</p>
      <p className='refnt'>Non Refundable</p>
      <p><strong>Cancellation Policy </strong> </p>
      <p>100.0% Deduction From 18 Sep 2025 till check-in</p>
    </td>
    <td>
      <p className='prce'>Price For 1 Night</p>
      <h4 className='cll_rupe'> <i className='fa fa-inr'></i> 15428 </h4>
       <a href='/Hotel/HotelBooking' className='bok-now'>Book</a>
    </td>
  </tr>
  <tr>
    <td>Deluxe Room (Deluxe Room),2 Twin Beds and 1 King Bed,NonSmoking</td>
    <td>2 Adults, 0 Child</td>
    <td>
      <p className='roon_only'>Room Only</p>
      <p className='refnt'>Non Refundable</p>
      <p><strong>Cancellation Policy </strong> </p>
      <p>100.0% Deduction From 18 Sep 2025 till check-in</p>
    </td>
    <td>
      <p className='prce'>Price For 1 Night</p>
      <h4 className='cll_rupe'> <i className='fa fa-inr'></i> 15428 </h4>
       <a href='/Hotel/HotelBooking' className='bok-now'>Book</a>
    </td>
  </tr>

</tbody>
      </table>

      <h3>View Map</h3>
      <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3500.9388299167663!2d77.08854552451122!3d28.661550182764202!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sB%20374%20Outer%20Ring%20Road%20Meera%20Bagh%20New%20Delhi%20110063%20India%20Outer%20Ring%20Road%2C%20Paschim%20Vihar%2C%20Meera%20BaghPaschim%20ViharNew%20Delhi%20110063%2C%20New%20Delhi%2C%20110063%2C%20India!5e0!3m2!1sen!2sin!4v1758278990634!5m2!1sen!2sin" width="100%" height="300" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

      <h3>Amenities</h3>
      <ul className='aminities'>
        <li>DailyFree</li>
        <li>continental</li>
        <li>breakfast24-hour front</li>
        <li>deskBusiness</li>
        <li>centerExpress</li>
        <li>check-outMeeting</li>
        <li>rooms</li>
      </ul>
      

    </div>
  </div>
</div>

      </div>

    </section>
  </>

);

export default HotelDetail;
